// import React from 'react'
// import './Footer.css'

// const Footer = () => {
//   const today = new Date();

//   const currentYear = today.getFullYear()
//   return (
//     <div>
//   <footer className="mt-3" style={{background: '#000', color: "white" }} >
//     <div className="container py-5">
//       <div className="row py-3" >

//         <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
//           <h6 className="text-uppercase font-weight-bold mb-4 footer-head">About</h6>
//           <ul className=" footerList mb-0" style={{color: "#fff"}} >
//             <li className="mb-2" ><a href="#" >Contact Us</a></li>
//             <li className="mb-2"><a href="#" >About Us</a></li>
//             <li className="mb-2"><a href="#" >Stories</a></li>
//             <li className="mb-2"><a href="#" >Press</a></li>
//           </ul>
//         </div>    

//         <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
//           <h6 className="text-uppercase font-weight-bold mb-4">Help</h6>
//           <ul className=" footerList mb-0">
//             <li className="mb-2"><a href="#" >Payments</a></li>
//             <li className="mb-2"><a href="#" >Shipping</a></li>
//             <li className="mb-2"><a href="#" >Cancellation</a></li>
//             <li className="mb-2"><a href="#" >Returns</a></li>
//           </ul>
//         </div>
        
//         <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
//           <h6 className="text-uppercase font-weight-bold mb-4">Policy</h6>
//           <ul className=" footerList mb-0">
//             <li className="mb-2"><a href="#" >Return Policy</a></li>
//             <li className="mb-2"><a href="#" >Terms Of Use</a></li>
//             <li className="mb-2"><a href="#" >Security</a></li>
//             <li className="mb-2"><a href="#" >Privacy</a></li>
//           </ul>
//         </div>
//         <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
//           <h6 className="text-uppercase font-weight-bold mb-4">Company</h6>
//           <ul className="footerList mb-0">
//             <li className="mb-2"><a href="#">Login</a></li>
//             <li className="mb-2"><a href="#" >Register</a></li>
//             <li className="mb-2"><a href="#" >Sitemap</a></li>
//             <li className="mb-2"><a href="#">Our Products</a></li>
//           </ul>
//         </div>
//         <div className="col-lg-4 col-md-6 mb-lg-0">
//           <h6 className="text-uppercase font-weight-bold mb-4">Registered Office Address</h6>
//           <p className=" mb-4" style={{color: "white"}}>Here , write the complete address of the Registered office address along with telephone number.</p>
//           <ul className="list-inline mt-4">
//             <li className="list-inline-item"><a href="#" target="_blank" title="twitter"><i className="fab  fa-2x fa-twitter"></i></a></li>
//             <li className="list-inline-item"><a href="#" target="_blank" title="facebook"><i className="fab fa-2x fa-facebook-f"></i></a></li>
//             <li className="list-inline-item"><a href="#" target="_blank" title="instagram"><i className="fab fa-2x fa-instagram"></i></a></li>
//             <li className="list-inline-item"><a href="#" target="_blank" title="pinterest"><i className="fab fa-2x fa-youtube"></i></a></li>
//             <li className="list-inline-item"><a href="#" target="_blank" title="vimeo"><i className="fab fa-2x fa-google"></i></a></li>
//           </ul>
//         </div>
//       </div>
//     </div>
//     <hr className="p-0 m-0 b-0"/>

   
//     <div className="bg-dark py-2" style={{color:"white"}}>
//       <div className="container text-center">
//         <p className="text-muted mb-0 py-2"></p>
//         Copyright &copy; {currentYear} All rights reserved |
//             <p className="text-muted mb-0 py-2"
//               href="http://ontractech.com"
//               target="_blank"
//               rel="noreferrer"
//               className="ml-2"
//             >
//               Ontrac Technology Limited
//             </p>
//         </div>
//       </div>
    
//   </footer>
//     </div>
//   )
// }

// export default Footer

import React, {useEffect, useState} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import '../Footer/scss/Footer2.scss';
import logo from '../../assets/logo2.png'
import logo1 from '../../assets/logo-part-1.png'
import SpinnerPage from '../hero/SpinnerPage';
import axios from '../../Utilities/axios'

const Footer = () => {
  const [isLoading, setIsLoading] = useState(false);

  const navigation = useNavigate();

  const getHotels = async(event) => {
    event.preventDefault();
    setIsLoading(true);
    const mainAvailableHotel = await axios.get(`/registrations/hotels?sourceType=showInCompanySite&hotelGroupName=Residency`);
    // setAvailableHotel(availableHotel.data)

    availableHotel = mainAvailableHotel.data
    setIsLoading(false);
    navigation("/availablehotels", {state: {availableHotel: availableHotel }})
  }

  let availableHotel

  const today = new Date();

    const currentYear = today.getFullYear()
  return (
    
  
  <div>
     {isLoading && <SpinnerPage />}

  <footer className="footer-area section_gap mt-4">
    <div className="container">
      <div className="row">
        <div className="col-lg-2  col-md-6 col-sm-6">
          <div className="single-footer-widget">
            <div className="form-inline">
              <div className="form-group">
                <span className="logo">
                  <img
                    src={logo1}
                    alt=""
                    width="100"
                  />
                </span>
                <span className="ml-n1">
                  <img src={logo} alt="" width="40" />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-6">
          <div className="single-footer-widget">
            <h6 className="footer_title">Navigation Links</h6>
            <div className="row">
              <div className="col-8">
                <ul className="list_style">
                 
                  <li  onClick={(event) => getHotels(event)}>
                  <Link>
                    Our Hotels
                    </Link>
                  </li>
                  
                  <li>
                    <Link to="/EventHall">Our Hall</Link>
                  </li>
                  {/* <li>
                    <Link to="/loyalty">Our Loyalty</Link>
                  </li> */}
                  <li>
                    <Link to="/About-Residency-Hotels">Our Company</Link>
                  </li>
                  {/* <li>
                    <Link to="/our-company">RHL Hotel Designs</Link>
                  </li> */}
                  {/* <li>
                    <Link to="/our-company">RHL Technology</Link>
                  </li> */}
                  {/* <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-6">
          <div className="single-footer-widget">
            <h6 className="footer_title">Useful Links</h6>
            <div className="row">
              <div className="col-md-8">
                <ul className="list_style">
                  <li>
                    <Link to="/Special-Promo">Our Promos</Link>
                  </li>
                  <li>
                    <Link to="/EventHall">Our Weddings</Link>
                  </li>
                  <li>
                    <Link to="/EventHall">Our Birthday Parties</Link>
                  </li>
                  <li>
                    <Link to="/EventHall">Our Special Events</Link>
                  </li>
                  {/* <li>
                    <Link to="/specialty-order">Our Specialty Foods</Link>
                  </li> */}
                  {/* <li>
                    <Link to="/our-company">RHL Technology</Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div className="single-footer-widget">
            <h6 className="footer_title">Contact Us</h6>
            <div className="row">
              <div className="col-md-8">
                <ul className="list_style">
                  <li>
                    <a href="#">Residency Hotels Limited</a>
                  </li>
                  <li>
                    <a href="#">
                      Plot 740, Nasir El Rufai Crescent, Guzape Hills, Abuja'
                    </a>
                  </li>
                  <li>
                    <a href="#">Customer Line: 08083664874</a>
                  </li>
                  <li>
                    <a href="#">Reservation: 08083664874</a>
                  </li>
                  <li>
                    <a href="#"> booking@myresidencyhotel.com</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border_line" />
      <div className="row footer-bottom d-flex justify-content-between align-items-center">
        <p className="col-lg-8 col-sm-12 footer-text m-0" style={{color: "white"}}>
          Copyright &copy; {currentYear} All rights reserved |
          <p
            href="http://ontractech.com"
            target="_blank"
            rel="noreferrer"
            className="ml-2"
          >
            Ontrac Technology Limited
          </p>
        </p>
        <div className="col-lg-4 col-sm-12 footer-social">
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <a href="https://www.facebook.com/windloungelagos" target="_blank">
            <i className="fa fa-facebook" />
          </a>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <a href="https://twitter.com/residency_hote" target="_blank">
            <i className="fa fa-twitter" />
          </a>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <a
            href="https://www.instagram.com/residency_hotels/"
            target="_blank"
          >
            <i className="fa fa-instagram" />
          </a>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        </div>
      </div>
    </div>
  </footer>
</div>
)
};

export default Footer;
